import { Box, List, ListItem, ListItemText } from '@mui/material';
import BaseTypography from 'core/components/typography/BaseTypography';
import { subscriptionPlansStyles } from 'core/layouts/components/subscription-plans/SubscriptionPlansStyles';
import React from 'react';

export function TermsAndConditions() {
	return (
		<Box id="terms-and-conditions" sx={subscriptionPlansStyles.subtext}>
			<BaseTypography
				variant="t1_v2_medium"
				styles={{ color: 'colors.white1', fontSize: '20px !important' }}
				id="terms-heading"
			>
				Terms and Conditions
			</BaseTypography>
			<Box
				id="terms-content"
				key="subscription-plans-subtext"
				sx={{
					color: 'colors.white1',
					whiteSpace: { xs: 'wrap', lg: 'nowrap' },
					marginLeft: '15px',
				}}
			>
				<List sx={{ listStyleType: 'decimal', p: 0 }} component="ol">
					<ListItem sx={{ display: 'list-item', p: 0 }}>
						{' '}
						<ListItemText
							primary="You can cancel your subscription anytime. After cancellation, you’ll still have access until the end of your billing period."
							primaryTypographyProps={{ ...subscriptionPlansStyles.termsConditions }}
						/>
					</ListItem>
					<ListItem sx={{ display: 'list-item', p: 0 }}>
						{' '}
						<ListItemText
							primary="Extra credit packs are available only with an active subscription and can only be used while the subscription is active."
							primaryTypographyProps={{
								...subscriptionPlansStyles.termsConditions,
							}}
						/>
					</ListItem>
					<ListItem sx={{ display: 'list-item', p: 0 }}>
						{' '}
						<ListItemText
							primary={
								<>
									Credit usage:
									<List sx={{ listStyleType: 'disc', ml: 2, p: 0 }} component="ul">
										<ListItem sx={{ display: 'list-item', p: 0 }}>
											<ListItemText
												primary="SDXL Image: 1 credit"
												primaryTypographyProps={{
													...subscriptionPlansStyles.termsConditions,
												}}
											/>
											<ListItem sx={{ display: 'list-item', p: 0 }}>
												<ListItemText
													primary="Flux Image: 5 credits"
													primaryTypographyProps={{
														...subscriptionPlansStyles.termsConditions,
													}}
												/>
											</ListItem>
										</ListItem>
										<ListItem sx={{ display: 'list-item', p: 0 }}>
											<ListItemText
												primary="Narration/Sec: 15 credits"
												primaryTypographyProps={{
													...subscriptionPlansStyles.termsConditions,
												}}
											/>
										</ListItem>
										<ListItem sx={{ display: 'list-item', p: 0 }}>
											<ListItemText
												primary="Music Video: 60 credits / 5 seconds"
												primaryTypographyProps={{
													...subscriptionPlansStyles.termsConditions,
												}}
											/>
										</ListItem>
										<ListItem sx={{ display: 'list-item', p: 0 }}>
											<ListItemText
												primary="Runway Video: 60 credits / 5 seconds"
												primaryTypographyProps={{
													...subscriptionPlansStyles.termsConditions,
												}}
											/>
										</ListItem>
										<ListItem sx={{ display: 'list-item', p: 0 }}>
											<ListItemText
												primary="Minimax/Kling Video: 120 credits / 5 seconds"
												primaryTypographyProps={{
													...subscriptionPlansStyles.termsConditions,
												}}
											/>
										</ListItem>
										<ListItem sx={{ display: 'list-item', p: 0 }}>
											<ListItemText
												primary="Google Video: 600 credits / 5 seconds"
												primaryTypographyProps={{
													...subscriptionPlansStyles.termsConditions,
												}}
											/>
										</ListItem>
									</List>
								</>
							}
							primaryTypographyProps={{ ...subscriptionPlansStyles.termsConditions }}
						/>
					</ListItem>
				</List>
			</Box>
		</Box>
	);
}
